<div class="apply-holiday">
    <div class="holiday-card">
        <div class="holiday-card__title-row">
            <div class="holiday-card__title">Add holiday</div>
            <button type="button" class="holiday-card__close" (click)="close()" aria-label="Close">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="holiday-card__grid">
            <div class="holiday-field">
                <div class="holiday-field__label">From date</div>
                <div class="holiday-date-wrap" (click)="holidayFromPicker.open()">
                    <input matInput [matDatepicker]="holidayFromPicker" [(ngModel)]="holidayFromDate"
                        name="holidayFromDate" class="form-control holiday-date-input" placeholder="From date"
                        [min]="minHolidayDate" [matDatepickerFilter]="holidayDateFilter"  />
                    <mat-datepicker-toggle matSuffix [for]="holidayFromPicker" class="holiday-date-toggle">
                    </mat-datepicker-toggle>
                </div>
                <mat-datepicker #holidayFromPicker></mat-datepicker>
            </div>

            <div class="holiday-field">
                <div class="holiday-field__label">To date</div>
                <div class="holiday-date-wrap" (click)="holidayToPicker.open()">
                    <input matInput [matDatepicker]="holidayToPicker" [(ngModel)]="holidayToDate"
                        name="holidayToDate" class="form-control holiday-date-input" placeholder="To date"
                        [min]="minHolidayDate" [matDatepickerFilter]="holidayDateFilter"  />
                    <mat-datepicker-toggle matSuffix [for]="holidayToPicker" class="holiday-date-toggle">
                    </mat-datepicker-toggle>
                </div>
                <mat-datepicker #holidayToPicker></mat-datepicker>
            </div>
        </div>

        <div class="holiday-reasons">
            <div class="holiday-reasons__label">Reason</div>

            <label class="holiday-radio" *ngFor="let h of holidayDetails">
                <input type="radio" name="holidayReason" [(ngModel)]="holidayReason" [value]="h.holidayName" />
                <span class="holiday-radio__label">{{ h.holidayName }}</span>
            </label>

            <label class="holiday-radio">
                <input type="radio" class="holiday-radio__input" name="holidayReason" [(ngModel)]="holidayReason"
                    [value]="'OTHER'" />
                <span>Other</span>
            </label>

            <div class="holiday-other" *ngIf="holidayReason === 'OTHER'">
                <input type="text" class="form-control" [(ngModel)]="holidayOtherText" name="holidayOtherText"
                    placeholder="Enter other reason" />
            </div>
        </div>

        <div class="holiday-card__actions">
            <button type="button" class="sbd__btn" (click)="submitHoliday()">Submit</button>
        </div>
    </div>
</div>
